import { Box, IconButton, Menu, MenuItem } from '@mui/material'
import React from 'react'

import Icon from 'components/Icon'
import { useTranslation } from 'hooks/use-translation'

export const NodeActionsMenu: React.FC<{
  id: string
  onEdit?: () => void
  onRemove?: () => void
  onMoveUp?: () => void
  onMoveDown?: () => void
}> = ({ id, onEdit, onRemove, onMoveUp, onMoveDown }) => {
  const { trans } = useTranslation()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleCloseMenu = () => {
    setAnchorEl(null)
  }

  const buttonId = `node-actions-menu-${id}`
  const menuId = `node-actions-menu-${id}`

  return (
    <Box>
      <IconButton
        aria-controls={open ? menuId : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        aria-label="more"
        id={buttonId}
        onClick={handleOpenMenu}
      >
        <Icon css={{ width: 20, height: 20 }} icon="solidEllipsisVertical" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id={menuId}
        MenuListProps={{
          'aria-labelledby': buttonId
        }}
        open={open}
        onClose={handleCloseMenu}
      >
        {onEdit && (
          <MenuItem
            data-testid={`edit-node-menu-item-${id}`}
            onClick={() => {
              handleCloseMenu()
              onEdit()
            }}
          >
            {trans('edit')}
          </MenuItem>
        )}
        {onRemove && (
          <MenuItem
            data-testid={`remove-node-menu-item-${id}`}
            onClick={() => {
              handleCloseMenu()
              onRemove()
            }}
          >
            {trans('delete')}
          </MenuItem>
        )}
        {onMoveUp && (
          <MenuItem
            data-testid={`move-up-node-menu-item-${id}`}
            onClick={() => {
              handleCloseMenu()
              onMoveUp()
            }}
          >
            {trans('move_up')}
          </MenuItem>
        )}
        {onMoveDown && (
          <MenuItem
            data-testid={`move-down-node-menu-item-${id}`}
            onClick={() => {
              handleCloseMenu()
              onMoveDown()
            }}
          >
            {trans('move_down')}
          </MenuItem>
        )}
      </Menu>
    </Box>
  )
}
